import React from "react";

function LogoutConfimation({ onLogout, onCancel }) {
  return (
    <>
      <div className="fixed z-50 inset-0 overflow-y-auto font-sans">
        <div className="flex items-center justify-center min-h-screen p-4 text-center sm:p-6">
          <div
            className="fixed inset-0 min-h-screen transition-opacity"
            aria-hidden="true"
          >
            <div className="absolute inset-0 bg-foreground/60" onClick={onCancel}></div>
          </div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div
            className="inline-block align-bottom bg-card rounded-xl border border-border px-4 pt-5 pb-4 overflow-hidden shadow-theme transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="h-1.5 card-gradient-strip -mx-4 sm:-mx-6 -mt-5 sm:-mt-6 rounded-t-xl" />
            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                onClick={onCancel}
                data-behavior="cancel"
                className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary text-muted-foreground hover:text-accent focus:outline-none transition-all duration-300"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-secondary sm:mx-0 sm:h-10 sm:w-10">
                <svg
                  className="h-6 w-6 text-accent"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <p className="font-heading text-xl leading-6 text-primary font-bold">Logout</p>
                <h3
                  className="text-sm leading-6 font-medium text-muted-foreground"
                  id="modal-headline"
                >
                  Are you sure you want to logout?
                </h3>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
              <button
                type="button"
                onClick={onLogout}
                className="bef-btn-primary w-full sm:w-auto"
              >
                Yes, I&apos;m sure
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="bef-btn-secondary w-full sm:w-auto"
              >
                No Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default LogoutConfimation;
